<template>
  <div class="header index_header">
    <div class="pre">
      <div class="header_inner">
        <div class="header_logo fl">
          <a>
            <img
              :src="childItem.propsValue.data.customField1"
              width="100%"
            />
          </a>
        </div>
        <div class="header_r fr">
          <div class="header-nav fl"></div>
          <div class="header-box">
            <img
              style="
                display: block;
                float: left;
                margin-top: 25px;
                margin-right: 5px;
              "
              src="https://mks.yybip.com/group1/M00/08/EA/CgoRC2MYZouASnoeAAACi2735ig36.jpeg"
            />
            <a style="display: block; float: right" class="login">{{
              childItem.propsValue.data.customField2
            }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MkHeaderWeb",
  props: {
    childItem: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      fields: [
        {
          code: "customField1",
          label: "图片",
          type: "image",
          width: 84,
          height: 62,
        },
        {
          code: "customField3",
          label: "链接",
          type: "text",
        },
        {
          code: "customField2",
          label: "电话",
          type: "text",
        },
      ],
      data: {
        customField1: "https://mks.yybip.com/group1/M00/01/3B/CgoRDGMYZmGAHJsqAAAMhr5ZOHY294.png",
        customField2: "4006-600-577",
        customField3: "",
      },
    };
  },
};
</script>


<style lang="scss" scoped>
.header {
  width: 880px;
  height: 70px;
  z-index: 9;
  background: #fff;
  box-shadow: 0 0px 11px 0 rgba(0, 0, 0, 0.1);
}
.header_inner {
  width: 880px;
  margin: 0 auto;
}
.header .header_logo a {
  display: block;
  width: 70px;
  height: 45px;
  margin-top: 10px;
}
.header-box {
  width: 220px;
  float: right;
  display: inline;
  margin-left: 20px;
}
.fl {
  float: left;
  display: inline;
}

.fr {
  float: right;
  display: inline;
}
.login {
  color: #e60012;
  line-height: 70px;
  font-size: 24px;
  margin-right: 15px;
}
</style>
